/* eslint-disable react/no-array-index-key */
import { List } from "@mui/material"
import { ReactElement } from "react"
import { useNavigate } from "react-router-dom"

import MobileListItems from "./mobileListItems"
import { INSTALLER_SINGLE_APPLICATION_BASE } from "../../../../router/routes"
import { IListApplications } from "../../../../services/middleware/types/installerInterface/installerApplicationTypes"
import { formatDate } from "../../../../utils/general/generalUtils"
import MobileListApplicationSkeleton from "../../../loading/skeletons/mobileListApplicationSkeleton"

interface IInstallerApplicationListMobileProps {
    searchResults: IListApplications
    isLoading: boolean
}

const ADDRESS_TRUNCATE_LENGTH = 40

const skeletonArray = Array.from({ length: 15 }, () => 0)

/**
 * Mobile friendly list of applications for Installers to view. Users can swipe
 * right to respond to an application
 */
const InstallerApplicationListMobile = ({
    searchResults,
    isLoading,
}: IInstallerApplicationListMobileProps): ReactElement => {
    const navigate = useNavigate()
    return (
        <List sx={{ pt: "0px" }}>
            {isLoading
                ? skeletonArray.map((_, index) => (
                      <MobileListApplicationSkeleton key={index} />
                  ))
                : (searchResults as IListApplications).map((application) => (
                      <MobileListItems
                          key={application.applicationId}
                          lcts={application.lcts}
                          title={
                              String(
                                  application.installerCustomerDetails
                                      .mainAddress
                              ).length < ADDRESS_TRUNCATE_LENGTH
                                  ? `${String(
                                        application.installerCustomerDetails
                                            .mainAddress
                                    )}`
                                  : `${String(
                                        application.installerCustomerDetails
                                            .mainAddress
                                    ).substring(0, ADDRESS_TRUNCATE_LENGTH)}...`
                          }
                          subtitle={formatDate(application.createdDate)}
                          subtitleAdditional={application.applicationStatus}
                          chipText={formatDate(application.createdDate)}
                          isUnread={application.isInstallerThreadUnread}
                          onClick={() =>
                              navigate(
                                  `${INSTALLER_SINGLE_APPLICATION_BASE}/${application.applicationId}`
                              )
                          }
                      />
                  ))}
        </List>
    )
}
export default InstallerApplicationListMobile
